module.exports = __webpack_public_path__ + "static/media/nhs_swl.f8adc744.jpg";